import { fetchBuildersLocations } from '../../services/fetchBuildersLocations';
import { TThunkAction } from '../../types/redux';
import { setLocationsData } from './setLocationsData';
import { startFetching } from './startFetching';

export const fetchLocations = (): TThunkAction => {
  return async (dispatch, _getState, context) => {
    dispatch(startFetching());

    const data = await fetchBuildersLocations(context);

    dispatch(setLocationsData(data));
  };
};
